import React from 'react';
import useMediaQuery from '../utils/useMediaQuery';

/**
 * The body wrapper for a list of EventListItem.
 *
 *   view="list"  — from ~900px, one 2px-bordered block whose rows divide
 *                  themselves with border-bottom (the last row's doubles as the
 *                  block's bottom edge, so the frame omits its own).
 *                  Below that the rows become side-thumb cards that draw their
 *                  own frame, so they stack with a gap instead.
 *   view="grid"  — the 2-up card grid at gap 24px, single column on phones.
 */
export default function EventListFrame({ view = 'list', className = '', children }) {
  const isWide = useMediaQuery('(min-width: 900px)');

  if (view === 'list') {
    if (!isWide) return <div className={`flex flex-col gap-5 ${className}`}>{children}</div>;
    // Desktop table (design handoff "Event list table", Sep 2026): a full-bordered block with a
    // black header; each row is a CSS-grid line that reveals a hover-only actions cell.
    return (
      <div className={`overflow-hidden border-2 border-black bg-white ${className}`}>
        <div
          className="grid items-stretch bg-black font-mono text-[12px] uppercase tracking-[0.12em] text-white"
          style={{ gridTemplateColumns: '180px minmax(260px,1fr) 180px 180px 190px' }}
        >
          <div className="px-4 py-2.5">When</div>
          <div className="px-4 py-2.5">Event</div>
          <div className="px-4 py-2.5">Status</div>
          <div className="px-4 py-2.5">Poster</div>
          <div className="px-4 py-2.5">Tickets</div>
        </div>
        {children}
      </div>
    );
  }

  return <div className={`grid grid-cols-1 gap-6 md:grid-cols-2 ${className}`}>{children}</div>;
}
